/* eslint-disable no-param-reassign */
import { message as antdMessage } from 'antd';
import { APP_CONFIG } from 'config';
// import * as Sentry from '@sentry/nextjs';

// 拼接host
import { Notify } from 'react-vant';
// import { captureError } from 'libs/sentry';
import spartaHeader from 'libs/sparta';

import { getHref } from './urls';
import { isMobileMall } from './utils';
import { doDownLoadFile } from 'libs/downLoadFile';

const SERVER_FETCH_TIMEOUT = 5 * 60 * 1000; // 5分钟

// eslint-disable-next-line prefer-destructuring
const ENV = process.env.ENV || 'local'; // 本地联调时未注入环境变量，默认是local
// 拼接本地联调时，后端endPoint地址

// node 端发起请求的网关地址
const HOSTS = {
  local: APP_CONFIG.HOST_URL,
  zjdev: `http://ifs-gw.dev.3jyx.cn`,
  zjst: 'http://ifs-gw.st.3jyx.cn',
  zjpre: "http://ifs-gw.pre.3jyx.cn",
  zjga: "http://ifs-gw.ga.3jyx.cn"
};

 const isServer = typeof window === 'undefined';

// const tenant = process.env.TENANT
// if (tenant) {
//   HOSTS.dev = `http://${tenant}.dev.pazc.paic.com.cn`
// }

const defaultOptions: RequestInit = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  credentials: 'include',
};
type FetchOptionsProps = FetchOptions & {
  fileName?: string;
  downLoad?: boolean;
}

type DopModule = {
  default?: any;
  isInDop?: () => Promise<boolean>;
};

async function attachDopHeaders(fetchOptions: FetchOptionsProps) {
  if (isServer) {
    return;
  }

  try {
    const dopModule: DopModule = await import('libs/dopUtil');
    const dopAppInstance = dopModule.default;
    const { isInDop } = dopModule;

    if (!dopAppInstance || typeof isInDop !== 'function') {
      return;
    }

    const inDop = await isInDop();
    if (!inDop) {
      return;
    }

    const tokenInfo = (await dopAppInstance.getToken?.()) || {};
    const { departmentId, accessToken, orgId } = tokenInfo;

    if (departmentId && departmentId !== 'slt') {
      (fetchOptions.headers as any).DepartmentId = departmentId;
      (fetchOptions.headers as any).DopToken = accessToken;
      (fetchOptions.headers as any)['X-ORG-ID'] = orgId;
    }
  } catch (err) {
    // 保底兜底, 避免因 DOP 相关问题影响主业务
    // eslint-disable-next-line no-console
    console.log('mallfe dop attach headers error', err);
  }
}

async function tabeFetch<T = any>(url: RequestInfo, options: FetchOptionsProps & {
    filename?: string;  // 自定义文件名
    onProgress?: (progress: number) => void;  // 下载进度回调
  }) {

  if (options?.serverSide) {
    url = `${HOSTS[ENV]}${url}`;
    options.wantError = true;

    // NOTE: 服务器端渲染时,context.req.header 传递过来，这里修改host会影响 hostname，从而影响 「移动&PC判断」
    // 这里的 host 不能乱指定，服务接口 会校验这个 host 信息
    if (options.headers && ENV === 'local') {
      options.headers.host = APP_CONFIG.HOST;
    }
  }

  const query = options?.query;

  // 处理GET请求的 Query查询参数
  if (query) {
    const queryArr = Object.keys(query).map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`,
    );
    if (queryArr.length > 0) {
      url = `${url}?${queryArr.join('&')}`;
    }
  }
 
  // let cookieObj = {};
  // if (!isServer) {
  //   const miniKey = sessionStorage.getItem('miniKey') as string;
  //   if ( miniKey) {
  //     cookieObj = {
  //       'x-mini-key': `${miniKey}`,
  //     };
  //   }
  // }
  // if (isServer) {
  //   const miniKey = options?.headers?.['x-mini-key'] as string;
  //   if ( miniKey ) {
  //     cookieObj = {
  //       'x-mini-key': `${miniKey}`,
  //     };
  //   }
  // }

  const headers = options?.headers
    ? {
        ...defaultOptions.headers,
        ...options.headers,
        'Content-Type': 'application/json; charset=utf-8',
      }
    : defaultOptions.headers;
  const fetchOptions: FetchOptionsProps = options
    ? {
        ...defaultOptions,
        ...options,
        headers,
      }
    : defaultOptions;

  fetchOptions.headers = {
    ...fetchOptions.headers,
    ...(!fetchOptions.serverSide &&
      spartaHeader && {
        'X-Sparta-Data': spartaHeader,
      }),
  };

  await attachDopHeaders(fetchOptions);


  // 处理 POST 请求，请求体数据
  if (options?.json) {
    fetchOptions.body = JSON.stringify(options.json);
  }

  const res = await doFetch(fetchOptions, url as string);

  const { status, statusText } = res;
  if (fetchOptions.needLogin && status === 401) {
    handleError(
      {
        code: status,
        message: statusText,
      },
      url as string,
      fetchOptions.serverSide,
    );
  }
  if(fetchOptions?.downLoad) {
    doDownLoadFile(res, fetchOptions.fileName)
    return 
  }
  if (!res.ok) {
    if (!fetchOptions.wantError) {
      handleError(
        {
          code: status,
          message: statusText,
        },
        url as string,
        fetchOptions.serverSide,
      );
      return {
        code: res.status,
        message: res.statusText,
      };
    } else {
      const e: any = new Error();
      e.code = res.status;
      e.message = res.statusText;
      e.url = url;
      throw e;
    }
  }

  let json: APIJSON<T>;
  try {
    json = await res.json();
  } catch (err) {
    // if (url === '/error') {
    //   // 在极端情况下（比如 weixin-cscec3b-m.tabe.cn 这个域名），/error 并没有路由到 mallfe 的 server 进程
    //   // 而此时返回一个非 json 的 body，如 404 页面
    //   // 就会陷入 recordError => catch err => recordError 的死循环
    //   // ignore
    // } else if (options?.serverSide) {
    //   Sentry.captureException(err, {
    //     level: 'error',
    //     tags: {
    //       error_type: 'json_parse_error',
    //       request_side: 'server',
    //     },
    //     contexts: {
    //       request: {
    //         url: url as string,
    //         status: res.status,
    //         statusText: res.statusText,
    //       },
    //     },
    //   });
    // } else {
    //   Sentry.captureException(err, {
    //     level: 'error',
    //     tags: {
    //       error_type: 'json_parse_error',
    //       request_side: 'client',
    //     },
    //     contexts: {
    //       request: {
    //         url: url as string,
    //         status: res.status,
    //         statusText: res.statusText,
    //       },
    //     },
    //   });
    // }
    return {
      code: 500,
      message: 'JSON format error',
    };
  }

  if (json.code === 400101 && !options?.serverSide) {
    (window as any).paIsKicked = true;
  }
  if (json.code === 400101 && fetchOptions.needLogin) {
    handleError(
      {
        code: json.code,
        message: json.message,
      },
      url as string,
      fetchOptions.serverSide,
    );
    return json;
  }

  if (json.code === 401 && fetchOptions.needLogin) {
    handleError(
      {
        code: json.code,
        message: json.message,
      },
      url as string,
      fetchOptions.serverSide,
    );
  } else if (json.code === 401 && !fetchOptions.wantError) {
    // ignore and return
    return json;
  } else if (json.code !== 200 && !fetchOptions.wantError) {
    if (!(json.code === 400101 && !fetchOptions.needLogin)) {
      handleError(
        {
          code: json.code,
          message: json.message,
        },
        url as string,
        fetchOptions.serverSide,
        fetchOptions.noErrorTip
      );
    }
    return json;
  } else if (json.code !== 200 && fetchOptions.wantError) {
    const e: any = new Error();
    e.code = json.code;
    e.message = json.message;
    e.url = url;
    throw e;
  } else {
    return json;
  }
}

async function doFetch(fetchOptions: FetchOptionsProps, url: string) {
  if (fetchOptions.serverSide) {
    // server端请求都给个超时，防止被后台ddos
    if (!fetchOptions.timeout) {
      fetchOptions.timeout = SERVER_FETCH_TIMEOUT;
    }
  }
  
  try {
    const res = await fetch(url, fetchOptions);
    return res;
  } catch (error) {
    if (typeof navigator === 'undefined' || !navigator.onLine) {
      // 服务端请求或者在客户端请求断网状态下
      return {
        ok: false,
        status: 600,
        statusText: '网络错误',
        // eslint-disable-next-line
        json: () => {}, // HACK: deceive typescript
      };
    } else {
      return {
        ok: true,
        status: 200,
        statusText: '',
        // eslint-disable-next-line
        json: () => ({
          code: 200,
          data: null,
          message: '',
        }),
      };
    }
  }
}

export function handleError(
  { code, message }: APIJSON<any>,
  url: string,
  serverSide?: FetchOptionsProps['serverSide'],
  noErrorTip?: FetchOptionsProps['noErrorTip']
) {
  if (code === 400101) {
    window.location.href = `/sso/logout?return_url=${encodeURIComponent(
      window.location.href,
    )}&type=kick_offline`;
    return;
  }
  if (code === 401 && serverSide) {
    if (typeof serverSide === 'object') {
      (serverSide.res as any)?.redirect(
        `${getHref('/login')}?return_url=${encodeURIComponent(
          (serverSide.req as any).originalUrl,
        )}`,
      );
    }
  } else if (code === 401) {
    window.location.href = `${getHref('/login')}?return_url=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`;
  } else if (code !== 200) {
    if (serverSide) {
      // captureError({ message, url });
    } else if (!noErrorTip) {
      const msg = <span dangerouslySetInnerHTML={{ __html: message }} />;
      isMobileMall(null) ? Notify.show({ type: 'danger', message: msg }) : antdMessage.error(msg);
    }
  }
}

/**
 * 记录异常
 * @param err
 */
export async function recordError(err: any, url?: string) {
  try {
    const res = await tabeFetch('/error', {
      method: 'POST',
      json: err instanceof Error ? { message: url ? `${url}\n${err.stack}` : err.stack } : err,
      wantError: true,
    });
    return res;
  } catch {
    // ignore
  }
}

export { tabeFetch as fetch };

// 导出工具函数
export const responseInterceptor = <T=any>(response: Promise<APIJSON<T>>) => {
  return new Promise<APIJSON<T>>(async (resolve, reject) => {
    const result = await response;
    if (result.code === 200) {
      resolve(result);
    } else {
      reject(result);
    }
  });
};

/**
 * 下载文件的通用方法
 * @param url 下载地址
 * @param options 请求配置
 * @param filename 自定义文件名（可选）
 * @returns Promise
 */
export async function downloadFile(
  url: string,
  options?: FetchOptionsProps & {
    filename?: string;  // 自定义文件名
    onProgress?: (progress: number) => void;  // 下载进度回调
  }
) {
  try {
    // 设置请求头
    const fetchOptions: FetchOptionsProps = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options?.headers,
        'Content-Type': 'application/octet-stream;charset=UTF-8',
      },
    };

    // 处理 POST 请求体
    if (options?.json) {
      fetchOptions.body = JSON.stringify(options.json);
    }

    // 如果是服务端请求，需要拼接完整的 URL
    if (options?.serverSide) {
      url = `${HOSTS[ENV]}${url}`;
    }

    const response = await fetch(url, fetchOptions);

    // 处理错误响应
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 获取文件名
    let filename = options?.filename;
    if (!filename) {
      const disposition = response.headers.get('content-disposition');
      if (disposition && disposition.includes('FileName=')) {
        filename = disposition
          .split('FileName=')[1]
          .trim()
          .replace(/"/g, '');
        // 处理中文文件名
        try {
          // NOTE: 这里需要抽象
          filename = decodeURIComponent(filename);
          const latin1Bytes = new Uint8Array(filename.length);
          for (let i = 0; i < filename.length; i++) {
            latin1Bytes[i] = filename.charCodeAt(i);
          }

          // 2. 用 UTF-8 解码字节数组
          const decoder = new TextDecoder('utf-8');
          filename = decoder.decode(latin1Bytes);
        } catch (e) {
          console.warn('文件名解码失败', e);
        }
      }
    }

    // 如果支持 ReadableStream
    if (response.body) {
      const reader = response.body.getReader();
      const contentLength = +response.headers.get('Content-Length');
      let receivedLength = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        // 计算下载进度
        if (contentLength && options?.onProgress) {
          options.onProgress((receivedLength / contentLength) * 100);
        }
      }

      // 合并数组缓冲区
      const chunksAll = new Uint8Array(receivedLength);
      let position = 0;
      for (const chunk of chunks) {
        chunksAll.set(chunk, position);
        position += chunk.length;
      }

      // 创建 Blob 对象
      const blob = new Blob([chunksAll]);
      
      // 创建下载链接并触发下载
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return {
        code: 200,
        message: '下载成功',
        data: null
      };
    } else {
      // 降级处理：直接获取 blob 数据
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return {
        code: 200,
        message: '下载成功',
        data: null
      };
    }
  } catch (error) {
    // 错误处理
    if (!options?.wantError) {
      handleError(
        {
          code: 500,
          message: error.message || '下载失败',
        },
        url,
        options?.serverSide,
        options?.noErrorTip
      );
      return {
        code: 500,
        message: error.message || '下载失败',
        data: null
      };
    }
    throw error;
  }
}


